var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cadfm-container-horizontal"},[_c('Left',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisibleLeft),expression:"isVisibleLeft"}],attrs:{"lang":_vm.lang.Left}}),_vm._v(" "),_c('Middle',{attrs:{"routingData":_vm.routingData,"lang":_vm.lang.Middle}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9237e220","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LibraryManager/Views/Properties.vue
// module id = null
// module chunks = 